import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import PlanInfoCard from './PlanInfoCard';

const CarouselInfoCard = ({ ...props }) => {
  const {
    plans,
    cycle,
    selectedPlan,
    leftActionDisabled,
    setSelectedCardPlanIndex,
    rightActionDisabled,
  } = props;

  const [selectedPlanIndex, setSelectedPlanIndex] = useState(undefined);
  const [carouselPlans, setCarouselPlans] = useState([]);

  const handlePlanClick = (plan, index) => {
    if (plan && !plan.empty) {
      if (!plan.disabled && !plan[cycle + '_disabled']) {
        if (index === selectedPlanIndex - 1) {
          setSelectedCardPlanIndex((prevIndex) => prevIndex - 1);
        } else if (index === selectedPlanIndex + 1) {
          setSelectedCardPlanIndex((prevIndex) => prevIndex + 1);
        }
      }
    }
  };

  useEffect(() => {
    if (plans && plans.length > 0 && selectedPlan) {
      setCarouselPlans([{ empty: true }, ...plans, { empty: true }]);

      setSelectedPlanIndex(
        [{ empty: true }, ...plans, { empty: true }].findIndex(
          (plan) => plan?.id === selectedPlan?.id
        )
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans, selectedPlan]);

  return (
    <div className='plan-card-wrapper d-flex flex-row justify-content-around align-items-center w-100 mt-3'>
      <div
        className={`arrow-left ${leftActionDisabled ? 'disabled' : ''}`}
        onClick={() => {
          !leftActionDisabled &&
            setSelectedCardPlanIndex((prevIndex) =>
              prevIndex === 0 ? 0 : prevIndex - 1
            );
        }}
      ></div>
      <div className='d-flex flex-row col-9 mx-0 justify-content-center align-items-center position-relative'>
        {carouselPlans &&
          carouselPlans.map((plan, index) => (
            <PlanInfoCard
              key={index}
              selected_plan={plan?.id === selectedPlan?.id}
              current_plan={plan?.current_plan}
              plan={plan}
              cycle={cycle}
              className={`${index !== selectedPlanIndex - 1 && index !== selectedPlanIndex + 1 && index !== selectedPlanIndex ? 'hidden' : 'mx-4'} ${index === selectedPlanIndex - 1 || index === selectedPlanIndex + 1 ? 'hidden-down-md' : ''}`}
              onClick={() => handlePlanClick(plan, index)}
            />
          ))}
      </div>
      <div
        className={`arrow-right ${rightActionDisabled ? 'disabled' : ''}`}
        onClick={() => {
          !rightActionDisabled &&
            setSelectedCardPlanIndex((prevIndex) =>
              prevIndex === plans.length - 1 ? plans.length - 1 : prevIndex + 1
            );
        }}
      ></div>
    </div>
  );
};

export default injectIntl(CarouselInfoCard);
